import { useCallback, useRef, useState } from 'react';

/**
 * One play button for the two videos of Compare (design d2): both start at the same time from
 * the same place, and both stop together.
 */
export function useComparePlayback(hasVideo: boolean) {
  const leftRef = useRef<HTMLVideoElement | null>(null);
  const rightRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const toggle = useCallback(() => {
    const videos = [leftRef.current, rightRef.current].filter((video): video is HTMLVideoElement => video !== null);
    if (isPlaying) {
      videos.forEach((video) => video.pause());
      setIsPlaying(false);
      return;
    }
    const start = Math.min(...videos.map((video) => video.currentTime));
    videos.forEach((video) => {
      // eslint-disable-next-line no-param-reassign -- the element of the side is the state to change
      video.currentTime = Number.isFinite(start) ? start : 0;
      video.play().catch(() => undefined);
    });
    setIsPlaying(true);
  }, [isPlaying]);

  return { leftRef, rightRef, isPlaying, toggle, hasVideo };
}
